module.exports = __webpack_public_path__ + "img/group-logo.1ffd2f48.svg";